import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';

export const convertKnmDocumentAttachmentFormValueToKnmData = (
  formAttachment: IKnmFormAttachment,
): IKnmAttachment | null => {
  const {
    guid,
    dateCreate,
    fileName,
    filePath,
    fileSize,
    mimeType,
    bucketName,
    correlationToken,
    hash,
    signed: isSigned,
    signatureInfo,
  } = formAttachment;

  if (!guid || !dateCreate || !fileName || !filePath || typeof fileSize !== 'number' || !mimeType || !bucketName) {
    return null;
  }

  return {
    guid,
    dateCreate,
    fileName,
    filePath,
    fileSize,
    mimeType,
    bucketName,
    correlationToken: correlationToken || null,
    hash: hash || null,
    signed: typeof isSigned === 'boolean' ? isSigned : null,
    signatureInfo: signatureInfo || null,
  };
};
